import { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Utensils,
  Leaf,
  Flame,
  UtensilsCrossed,
  IceCream,
  Salad,
  GlassWater,
  ArrowRight,
} from 'lucide-react';

const HERO_IMG =
  'https://customer-assets.emergentagent.com/job_574cc8bd-edef-41b9-82d3-6a702d274bcf/artifacts/9s7m3p8i_ChatGPT%20Image%20Jun%2015%2C%202026%2C%2011_12_12%20AM.png';

const CATEGORIES = [
  { id: 'starters-veg', name: 'Vegetarian Starters', icon: Leaf },
  { id: 'starters-nonveg', name: 'Non-Veg Starters', icon: Flame },
  { id: 'soups', name: 'Soups', icon: UtensilsCrossed },
  { id: 'chaats', name: 'Chaats', icon: Utensils },
  { id: 'mains-veg', name: 'Vegetarian Mains', icon: Leaf },
  { id: 'mains-nonveg', name: 'Non-Veg Mains', icon: Flame },
  { id: 'biryani', name: 'Biryani & Rice', icon: Utensils },
  { id: 'breads', name: 'Breads & Kulchas', icon: Utensils },
  { id: 'desserts', name: 'Desserts', icon: IceCream },
  { id: 'sides', name: 'Salads & Sides', icon: Salad },
  { id: 'drinks', name: 'Lassi & Mocktails', icon: GlassWater },
];

const MENU_DATA = {
  'starters-veg': {
    title: 'Vegetarian Starters',
    pricing: 'Vegetable Kebab R95 · Paneer Starters R125',
    items: [
      { name: 'Avocardo Gaulti Kebab', desc: 'Classic Gulati Kebab with a healthy twist — avocado meets the alternative trend.' },
      { name: 'Dhal Aranchini', desc: 'Lentil and rice stuffed with cheese, bedded on salsa.' },
      { name: 'Mexican Tikki', desc: 'Spiced patty made with corn, kidney beans and mixed vegetables.' },
      { name: 'Bhutta Cigahar Tikki', desc: 'Corn kernels marinated in sweet potatoes, served with cumin chilli cucumber raita.' },
      { name: 'Techa Paneer Cheese Bombs', desc: 'Finger paneer marinated with herbs and spices, deep fried with hot garlic sauce.' },
      { name: 'Kashmiri Yakhni Paneer', desc: 'Paneer cubes with cashew nut, trio peppers, mastered with home-made spices.' },
      { name: 'Paneer Tikka Multani', desc: 'Mildly spiced paneer tikkas with mint stuffing.' },
      { name: 'Chilli Paneer', desc: 'Pan tossed spiced cottage cheese with soya sauce flavour.' },
      { name: "Rajama and Paneer Pinwheel", desc: "Beetroot puri stuffed with rajma and mint chutney — Chef's Speciality." },
      { name: 'Hara Broccoli Cheese Balls', desc: 'Pan seared green peas and broccoli kebab served with hot spicy chutney.' },
      { name: 'Sizzling Fusion Vegetable Lollipop', desc: 'Garden fresh vegetables mashed, spiced and served with sweet chutney.' },
      { name: 'Soji Palak Cheese Poppers', desc: "Cheese stuffed in spinach semolina poppers, lightly spiced — Chef's Specialty." },
      { name: "Beet's and Fennel Paneer Tikki", desc: 'Pan-fried rounds of beetroot, crusted and grilled.' },
      { name: 'Crispy Vegetable Chilli', desc: 'Garden fresh vegetables sautéed in Schezwan sauce.' },
    ],
  },
  'starters-nonveg': {
    title: 'Non-Vegetarian Starters',
    pricing: 'Chicken R125 · Lamb R195 · Queen Prawn R320',
    items: [
      { name: 'Potli Prawns', desc: "Prawn mashed in homemade pastry with tangy spicy sauce — Chef's Speciality." },
      { name: 'Potli Murgh Kebab', desc: 'Boneless meat gently spiced with garlic, ginger, tossed in creamy cheese sauce.' },
      { name: 'Prawn Arancini', desc: 'A delightful prawn creation with spectacular herbs and spices.' },
      { name: 'Patili Ke Kebab', desc: 'Lucknow style kebabs focusing on quality and flavour.' },
      { name: 'Murgh Black Pepper Kebab', desc: 'Fluffy boneless chicken marinated in cashew paste, char grilled with saffron.' },
      { name: 'Chicken 65', desc: 'Chennai style boneless chicken with shallots.' },
      { name: 'Kapi Tamarind Kebab', desc: 'Madras coffee deboned meat, smoked charcoal and spices.' },
      { name: 'Chatpata Kebab', desc: 'Lemony mint and cashew paste, tempered with herbs and char grilled — Mumbai Style.' },
      { name: 'Kerala Style Pepper Chicken', desc: 'Semi gravy dry dish with coriander onion topping.' },
      { name: 'Butter Chicken Cheese Pops', desc: "Geet chef's specialty." },
      { name: 'Bhati Da Murgh Kebab', desc: 'Unique flavour of mango and pomegranate with dehydrated spices.' },
      { name: 'Anarkalli Kebab', desc: 'Meat kebabs with pomegranate morel flavour, tempered in mustard seeds — Kerala.' },
    ],
  },
  soups: {
    title: 'Soups',
    pricing: '',
    items: [
      { name: 'Patatoe Soup', desc: 'Mashed potato spheres spiced and laced on a clear creamy gravy.' },
      { name: 'Tom Young Soup', desc: 'A perfection of pan Asian flavour with a hint of sweet-sour taste.' },
      { name: 'Dhal Corn Palak Soup', desc: 'Creamy spinach and lentil soup with cumin crackled corn kernels.' },
      { name: 'Broccoli Almond Peppers Soup', desc: 'Garden fresh broccoli soup with apricot creamy flavour.' },
      { name: 'Tomato Soup', desc: 'Green and red tomatoes blanched and flavoured in basil.' },
      { name: 'Chicken Momo Soup', desc: 'Sweet and sour soup with homemade chicken momos.' },
      { name: 'Vegetable Momo Soup', desc: 'Sweet and sour soup with homemade vegetable momos.' },
    ],
  },
  chaats: {
    title: 'Chaats',
    pricing: 'All Chaats R95',
    items: [
      { name: 'Vegetarian Samosas', desc: 'Choose from: Cheese Corn Jalapeño, Paneer Bhurji, Potatoes, Mix Vegetable, Punjabi Samosa.' },
      { name: 'Non-Vegetarian Samosas', desc: 'Choose from: Chicken Jalapeño, Chicken Tikka, Lamb Bhurji, Prawn Bhurji.' },
      { name: 'Mint Pani Puri', desc: 'Marble crispy puri stuffed with mint water — mouth bombs.' },
      { name: 'Beetroot Pani Puri', desc: 'Homemade crispy puri laced with tangy fillings and beet chutney.' },
      { name: 'Boondi Pani Puri', desc: 'Lentil and tangy stuffed with mango mint water.' },
      { name: 'Seasonal Fruit Mango Pani Puri', desc: 'Crunchy fruit flavour dipped in mango minty water.' },
      { name: 'Malai Ice Cream Pani Puri', desc: "Chef's speciality crispy puri stuffed with Malai ice cream." },
      { name: 'Palak Pata Chaat', desc: 'Baby spinach chaat.' },
    ],
  },
  'mains-veg': {
    title: 'Vegetarian Mains',
    pricing: 'Vegetable Dishes R185 · Kofta Dishes R190',
    items: [
      { name: 'Paneer Manchurian', desc: 'A magical dish with ultimate twist that has you saying more please.' },
      { name: 'Pineapple Paneer', desc: 'Chargrilled pineapple and paneer Lucknow style in palak and pistachio creamy gravy.' },
      { name: 'Methi Malia Matar', desc: 'Hearty dish packed with spinach, fenugreek, garden peas in creamy gravy.' },
      { name: 'Dhingri Kali Mirch', desc: 'Mushroom packed with umami goodness in rich creamy black pepper gravy.' },
      { name: 'Kashmiri Dum Alu', desc: 'Potato cubes cooked in tomato cream base, flavoured with coriander.' },
      { name: 'Malaidar Saag', desc: 'Spinach puree simmered with green chili and garlic, finished with fresh coriander.' },
      { name: 'Badami Qourma Sabzi', desc: 'Seasonal garden greens cooked in almond cream puree.' },
      { name: 'Kolhapuri Vegetables', desc: 'Popular dish of Kolhapur with seasonal vegetables.' },
      { name: 'Kesar Malai Kofta', desc: 'Soft nuts stuffed cottage cheese koftas in rich cashew and yoghurt gravy.' },
      { name: 'Nawabi Kofta', desc: 'Malia curry with rich tender vegetable kofta in silky cashew nut gravy.' },
      { name: 'Makhmali Malia Kofta', desc: 'Cranberry nuts filled paneer kofta in velvety tomato gravy with saffron honey.' },
      { name: 'Rogan Kofta', desc: 'Decadent vegetable kofta in green, yellow, and red made in Rogan gravy.' },
    ],
  },
  'mains-nonveg': {
    title: 'Non-Vegetarian Mains',
    pricing: 'Chicken R210 · Lamb R250 · Ostrich R300 · Prawn / Fish / Duck R320',
    items: [
      { name: 'Butter Chicken', desc: 'Boneless chicken cooked in butter and tomato creamy gravy — Delhi.' },
      { name: 'Murgh Tikka Masala', desc: 'Boneless chicken cooked in tandoori oven then in tomato gravy — Delhi.' },
      { name: 'Rogan Josh', desc: 'Succulent pieces of lamb cooked in saffron and onion gravy — Delhi.' },
      { name: 'Laal Maas', desc: 'On the bone lamb with yogurt, ginger, garlic — Rajasthan.' },
      { name: 'Shai Qourma', desc: 'Boneless chicken in creamy cashew nut sauce with nuts and raisins — Lucknow.' },
      { name: 'Coconut Lime', desc: 'Delicate flavours of coconut, lemongrass, lime leaves with roasted red chilies — Kerala.' },
      { name: 'Allepy Curry', desc: 'South Indian style meat in coconut milk with mustard seeds and curry leaves.' },
      { name: 'Chettinand Pepper Masala', desc: 'Meat cooked with fennel seeds, peppercorn in coconut onion gravy — Madras.' },
      { name: 'Goshtaba', desc: 'Soft chicken stuffed lamb spheres in cardamom yogurt gravy — Signature of Kashmir.' },
      { name: 'Kosha Mangsho', desc: 'Bengali specialty slow roasted lamb on the bone — Kerala.' },
      { name: 'Nawabi Tava', desc: 'Chicken and prawn with onions and aromatic spices — Delhi (R350).' },
      { name: 'Shikandari Lamb Shank', desc: 'Signature dish (R350).' },
    ],
  },
  biryani: {
    title: 'Biryani & Rice',
    pricing: 'Chicken R210 · Lamb R250 · Ostrich R300 · Prawn R320',
    items: [
      { name: 'Hyderabad Dumki Biryani', desc: 'Meat and basmati rice cooked together in sealed pot with yoghurt and mint.' },
      { name: 'Awadh Biryani', desc: "Choice of meat marinated in chef's northern Indian herbs and spices." },
      { name: 'Mahaknwala Biryani', desc: 'Butter chicken flavour — tender meat in herbs and spice, steamed in saffron rice.' },
      { name: 'Rogan Biryani', desc: 'Rogan Josh flavour — tender meat in herbs and spice.' },
      { name: 'Nepalese Biryani', desc: 'Lamb, chicken and prawns in saffron basmati with raita (R375).' },
      { name: 'Lamb Shank Biryani', desc: 'Exotic lamb shank in saffron rice with flaky pastry (R375).' },
      { name: 'Banarasi Vegetable Biryani', desc: 'Basmati rice with vegetables and paneer enriched with khoya and dry fruits.' },
      { name: 'Rogani Paneer Biryani', desc: 'Basmati rice with dry fruits and paneer in Kashmiri Rogan josh spices.' },
      { name: 'Saffron Pulao', desc: 'Basmati rice with coriander and saffron (R60).' },
      { name: 'Peshawari Pulao', desc: 'Basmati rice with tutti fruity, dried fruit and nuts (R60).' },
      { name: 'Coconut Pulao', desc: 'Aromatic basmati rice with toasted coconut and coriander (R50).' },
    ],
  },
  breads: {
    title: 'Breads & Kulchas',
    pricing: 'Naan from R45 · Kulchas from R70',
    items: [
      { name: 'Rogni Naan', desc: 'Homemade bread from fermented dough with sesame seeds (R45).' },
      { name: 'Garlic & Olive Naan', desc: 'Unleavened bread topped with olives and garlic (R55).' },
      { name: 'Peshawari Naan', desc: 'Stuffed with dried fruits and raisins, baked to succulent sweetness.' },
      { name: 'Masala Cheese & Tomato Naan', desc: 'Stuffed with cheese, tomato and onion (R55).' },
      { name: 'Badami Naan', desc: 'Flavoured with crushed almonds and raisins (R55).' },
      { name: 'Saffron Naan', desc: 'Flavoured with coriander and saffron (R55).' },
      { name: 'Classic Aloo Pyaz Kulcha', desc: 'Roasted spices make this Punjabi kulcha delightful.' },
      { name: 'Paneer Makhni Kulcha', desc: 'Paneer bhurji masala stuffed and oven baked with dry fenugreek butter.' },
      { name: 'Mushroom Kulcha', desc: 'Masala mushroom and red onion stuffed, truffle oil drizzle (R75).' },
      { name: 'Butter Chicken Kulcha', desc: 'Stuffed with tandoori chicken (R85).' },
    ],
  },
  desserts: {
    title: 'Desserts',
    pricing: '',
    items: [
      { name: 'Gulab Jamun', desc: 'Homemade dumplings made from reduced milk.' },
      { name: 'Chocolate Samosas', desc: 'Belgian chocolate filled in pastry served with ice cream.' },
      { name: 'Chocolate Pani Puri', desc: 'Crispy balloon balls filled with date and nut, dipped in chocolate.' },
      { name: 'Gajar Halwa', desc: 'Homemade carrot halwa with Malai ice cream.' },
      { name: 'Gajar Ka Ras Malai', desc: 'A twist to dessert dunked in milk sauce.' },
      { name: 'Gulab Jambo Samosa', desc: 'Gulab jambo stuffed in homemade pastry.' },
      { name: 'Mango Kheer', desc: 'Rice pudding flavoured with fresh mango puree.' },
      { name: 'Shrikand', desc: 'Homemade cheesecake with seasonal fruit and mango kulfi.' },
      { name: 'Rabari Malai Ice Cream', desc: 'Choose: Mango Cardamom, Pistachio Saffron, or Rose scented.' },
      { name: 'Gelato Selection', desc: 'Vanilla & Choc Chip, Chocolate & Nougat, or Mango Gelato.' },
    ],
  },
  sides: {
    title: 'Salads & Sides',
    pricing: '',
    items: [
      { name: 'Papaya Salad', desc: 'Crispy garden green cabbage, papaya, tamarind, cashew nut.' },
      { name: 'Lentil Salad', desc: 'Mix lentil sprouts with garden veg and orange vinaigrette.' },
      { name: 'Greek Salad', desc: 'Leafy salad with feta, olives and Greek dressing.' },
      { name: 'Tandoori Paneer Avocado Salad', desc: 'Roasted avocado with roasted makhni paneer.' },
      { name: 'Roasted Tandoori Gobi Salad', desc: 'Light flavoured in peanut puree with garden greens.' },
      { name: 'Cucumber Raita', desc: 'Classic yogurt side.' },
      { name: 'Boondi Raita', desc: 'Crispy boondi in yogurt.' },
      { name: 'Mango Achari Raita', desc: 'Tangy mango pickle raita.' },
      { name: 'Pomegranate Raita', desc: 'Fresh pomegranate seeds in yogurt.' },
    ],
  },
  drinks: {
    title: 'Lassi & Mocktails',
    pricing: '',
    items: [
      { name: 'Mango Lassi', desc: 'Natural yoghurt mixed with mango pulp.' },
      { name: 'Sweet Lassi', desc: 'Classic sweet yogurt drink.' },
      { name: 'Salted Lassi', desc: 'Traditional salted yogurt drink.' },
      { name: 'Masala Lassi', desc: 'Spiced yogurt drink with cumin.' },
      { name: 'Strawberry Daiquiri', desc: 'Fresh strawberry juice, crushed ice with lime.' },
      { name: 'Piña Colada', desc: 'Pineapple juice, coconut cream, fresh pineapple cubes.' },
      { name: 'Red Passion', desc: 'Lychee puree, cranberry juice and grenadine syrup.' },
      { name: 'Apple Indian Punch', desc: 'Apple juice, mango purée, cinnamon orange syrup, cloves.' },
      { name: 'Bombay Crush Falooda', desc: 'Choose: Rose, Badami, Cardamom, Chocolate, Mango or Papaya.' },
    ],
  },
};

const MenuPage = () => {
  const [activeCategory, setActiveCategory] = useState('starters-veg');
  const currentMenu = MENU_DATA[activeCategory];

  return (
    <main data-testid="menu-page" className="bg-[#FAF6F0] text-[#1C1917]">
      {/* ============ HERO ============ */}
      <section
        data-testid="menu-hero"
        className="relative min-h-[75vh] md:min-h-[85vh] flex items-center overflow-hidden"
      >
        <div className="absolute inset-0">
          <img
            src={HERO_IMG}
            alt="Indian curries in brass pots with wine pairing"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#1C1917]/70 via-[#1C1917]/55 to-[#FAF6F0]/95" />
        </div>

        <div className="relative z-10 max-w-[1400px] w-full mx-auto px-6 md:px-12 lg:px-20 py-32">
          <div className="max-w-3xl text-center mx-auto lg:mx-0 lg:text-left">
            <div className="flex items-center justify-center lg:justify-start gap-3 mb-6">
              <span className="h-px w-12 bg-[#C9A227]" />
              <span className="font-['Cormorant_Garamond'] italic text-[#C9A227] text-sm md:text-base tracking-[0.4em] uppercase drop-shadow">
                Royal Cuisine · 2025 / 2026
              </span>
              <span className="h-px w-12 bg-[#C9A227]" />
            </div>

            <h1 className="font-['Marcellus'] text-4xl md:text-6xl lg:text-7xl text-[#FAF6F0] mb-6 leading-tight drop-shadow-[0_6px_24px_rgba(0,0,0,0.55)]">
              The Menu,
              <br />
              <span className="italic font-['Cormorant_Garamond'] text-[#FFE7A8]">a love letter in spice.</span>
            </h1>

            <p className="font-['Cormorant_Garamond'] text-lg md:text-xl text-[#FAF6F0]/95 max-w-2xl leading-relaxed drop-shadow mx-auto lg:mx-0">
              Eleven chapters of curries, breads, biryanis and quiet showstoppers — written by
              Chef Gita, served at your table.
            </p>
          </div>
        </div>
      </section>

      {/* ============ AWARD BANNER ============ */}
      <section
        data-testid="menu-award-banner"
        className="relative bg-[#1C1917] text-[#FAF6F0] py-5 md:py-6 overflow-hidden border-y border-[#C9A227]/30"
      >
        <div className="absolute inset-0 opacity-30 pointer-events-none">
          <div className="absolute top-1/2 left-1/4 -translate-y-1/2 w-72 h-72 rounded-full bg-[#C9A227] opacity-30 blur-3xl" />
          <div className="absolute top-1/2 right-1/4 -translate-y-1/2 w-72 h-72 rounded-full bg-[#7B2C2C] opacity-20 blur-3xl" />
        </div>
        <div className="relative max-w-5xl mx-auto px-6 flex flex-col md:flex-row items-center justify-center gap-3 md:gap-5 text-center">
          <span className="font-['Cormorant_Garamond'] italic text-[#C9A227] tracking-[0.4em] uppercase text-xs md:text-sm">
            ✦ Award Winning ✦
          </span>
          <span className="hidden md:block h-5 w-px bg-[#C9A227]/40" />
          <p className="font-['Marcellus'] text-base md:text-xl tracking-wide">
            Voted <span className="text-[#FFE7A8] italic font-['Cormorant_Garamond']">Best Indian Restaurant</span> in South Africa
          </p>
        </div>
      </section>

      {/* ============ CATEGORY TABS (sticky) ============ */}
      <section
        data-testid="menu-categories"
        className="sticky top-20 md:top-24 z-30 bg-[#FAF6F0]/95 backdrop-blur-md border-b border-[#C9A227]/25"
      >
        <div className="max-w-[1400px] mx-auto px-4 md:px-12">
          <div className="flex overflow-x-auto py-4 gap-2 md:gap-3 scrollbar-hide">
            {CATEGORIES.map((cat) => {
              const active = activeCategory === cat.id;
              return (
                <button
                  key={cat.id}
                  data-testid={`menu-cat-${cat.id}`}
                  onClick={() => setActiveCategory(cat.id)}
                  className={`flex items-center gap-2 px-4 py-2 rounded-full whitespace-nowrap transition-all duration-300 border ${
                    active
                      ? 'bg-[#1C1917] text-[#C9A227] border-[#1C1917]'
                      : 'bg-transparent text-[#3F3A30] border-[#C9A227]/30 hover:border-[#C9A227] hover:bg-[#F3EBDE]'
                  }`}
                >
                  <cat.icon size={15} />
                  <span className="font-['Cormorant_Garamond'] text-sm md:text-base tracking-wide">
                    {cat.name}
                  </span>
                </button>
              );
            })}
          </div>
        </div>
      </section>

      {/* ============ MENU CONTENT ============ */}
      <section className="relative py-20 md:py-28 overflow-hidden">
        <div className="absolute -top-32 -right-32 w-[28rem] h-[28rem] rounded-full bg-[#5C4A1F] opacity-10 blur-3xl pointer-events-none" />
        <div className="absolute -bottom-32 -left-32 w-[28rem] h-[28rem] rounded-full bg-[#C9A227] opacity-10 blur-3xl pointer-events-none" />

        <div className="relative max-w-[1100px] mx-auto px-6 md:px-12">
          {/* Category header */}
          <div className="text-center mb-14 md:mb-16">
            <div className="flex items-center justify-center gap-3 mb-5">
              <span className="h-px w-10 bg-[#C9A227]" />
              <span className="font-['Cormorant_Garamond'] italic text-sm tracking-[0.3em] uppercase text-[#C9A227]">
                Chapter {String(CATEGORIES.findIndex((c) => c.id === activeCategory) + 1).padStart(2, '0')}
              </span>
              <span className="h-px w-10 bg-[#C9A227]" />
            </div>
            <h2
              data-testid="menu-category-title"
              className="font-['Marcellus'] text-3xl md:text-5xl text-[#1C1917] mb-4 leading-tight"
            >
              {currentMenu.title}
            </h2>
            {currentMenu.pricing && (
              <p className="font-['Cormorant_Garamond'] italic text-lg md:text-xl text-[#5C4A1F]">
                {currentMenu.pricing}
              </p>
            )}
          </div>

          {/* Menu items grid */}
          <div className="grid md:grid-cols-2 gap-x-12 gap-y-8 md:gap-y-10">
            {currentMenu.items.map((item, idx) => (
              <div
                key={idx}
                data-testid={`menu-item-${activeCategory}-${idx}`}
                className="group border-b border-[#C9A227]/25 pb-6 hover:border-[#C9A227] transition-colors"
              >
                <div className="flex items-start gap-4">
                  <span className="font-['Marcellus'] text-2xl text-[#C9A227]/40 group-hover:text-[#C9A227] transition-colors leading-none mt-1 flex-shrink-0">
                    {String(idx + 1).padStart(2, '0')}
                  </span>
                  <div>
                    <h3 className="font-['Marcellus'] text-xl md:text-2xl text-[#1C1917] mb-2 tracking-wide leading-tight">
                      {item.name}
                    </h3>
                    <p className="font-['Cormorant_Garamond'] text-base md:text-lg text-[#3F3A30]/80 leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ============ CHEF'S NOTE ============ */}
      <section
        data-testid="menu-chef-note"
        className="relative py-16 md:py-20 bg-[#F3EBDE] overflow-hidden"
      >
        <div className="absolute -top-32 left-1/4 w-[28rem] h-[28rem] rounded-full bg-[#7B2C2C] opacity-10 blur-3xl pointer-events-none" />
        <div className="relative max-w-3xl mx-auto px-6 text-center">
          <div className="flex items-center justify-center gap-3 mb-5">
            <span className="h-px w-10 bg-[#7B2C2C]" />
            <span className="font-['Cormorant_Garamond'] italic text-sm tracking-[0.3em] uppercase text-[#7B2C2C]">
              From the Pass
            </span>
            <span className="h-px w-10 bg-[#7B2C2C]" />
          </div>
          <p className="font-['Cormorant_Garamond'] italic text-xl md:text-2xl text-[#1C1917] leading-relaxed">
            &ldquo;Please tell your server about any allergies or dietary needs — every dish on this
            menu can be tailored to your table. Prices are subject to change. Reservations are warmly
            recommended.&rdquo;
          </p>
          <p className="font-['Marcellus'] tracking-wider text-[#5C4A1F] mt-6 text-sm md:text-base">
            — CHEF GITA JIVAN
          </p>
        </div>
      </section>

      {/* ============ CTA FOOTER ============ */}
      <section className="relative py-20 md:py-28 bg-[#1C1917] text-[#FAF6F0] overflow-hidden border-t border-[#C9A227]/20">
        <div className="absolute inset-0 opacity-30 pointer-events-none">
          <div className="absolute top-0 left-1/4 w-96 h-96 rounded-full bg-[#C9A227] opacity-30 blur-3xl" />
          <div className="absolute bottom-0 right-1/4 w-96 h-96 rounded-full bg-[#7B2C2C] opacity-20 blur-3xl" />
        </div>

        <div className="relative max-w-3xl mx-auto px-6 text-center">
          <p className="font-['Cormorant_Garamond'] italic text-[#C9A227] text-sm tracking-[0.35em] uppercase mb-5">
            ✦  Ready to Order  ✦
          </p>
          <h2 className="font-['Marcellus'] text-3xl md:text-5xl mb-8 leading-tight">
            Let&apos;s save you <span className="italic text-[#FFE7A8]">the best table.</span>
          </h2>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link
              to="/geet/contact"
              data-testid="menu-reserve-btn"
              className="group inline-flex items-center gap-3 bg-[#C9A227] text-[#1C1917] px-8 py-4 font-['Cormorant_Garamond'] tracking-[0.25em] uppercase text-sm font-semibold rounded-lg hover:bg-[#FAF6F0] transition-all duration-300 shadow-lg"
            >
              Reserve a Table
              <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
            </Link>
            <Link
              to="/geet/about"
              className="inline-flex items-center gap-2 border border-[#C9A227]/60 text-[#C9A227] px-8 py-4 font-['Cormorant_Garamond'] tracking-[0.25em] uppercase text-sm rounded-lg hover:bg-[#C9A227]/10 transition-all duration-300"
            >
              Our Story
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default MenuPage;
